'use strict'

var Marionette = require('marionette')
var App = require('app')
var TabBehavior = require('src/behaviors/tabs')
var Gauge = require('src/common/gauge/')
var _ = require('lodash')
var convertUnit = require('convert-units')

/**
 * Status page View
 * -----------------------------------------------------------------------------
 */
var Layout = Marionette.View.extend({
  template: require('./templates/layout.html'),
  className: 'page page-status',
  events: {
    'click .js-toggle-list': 'onPeriodClick',
    'click .js-warning-click': 'onWarningClick'
  },
  modelEvents: {
    'change': 'updateCharts'
  },
  regions: {
    mapRegion: '.status-map-region',
    systemRegion: '.status-system-region'
  },
  initialize: function () {
    this.gauges = {}
    this.activePeriod = 'wtd'
  },
  onRender: function () {
    // // render the gauges
    this.chartUsage = new Gauge({element: this.el.querySelector('.js-energy-usage-gauge')})
    this.chartCosts = new Gauge({ element: this.el.querySelector('.js-energy-costs-gauge') })
    this.chartCo2 = new Gauge({ element: this.el.querySelector('.js-co2-gauge') })
     // //
    this.chartPrevUsage = new Gauge({ element: this.el.querySelector('.js-energy-usage-prev-gauge'), value: 0 })
    this.chartPrevCosts = new Gauge({ element: this.el.querySelector('.js-energy-costs-prev-gauge'), value: 0 })
    this.chartPrevCo2 = new Gauge({ element: this.el.querySelector('.js-co2-prev-gauge'), value: 0 })
    //
    this.updateCharts()
  },

  /* Event methods ----------------------------------------------------------- */
  onWarningClick: function () {
    App.globalChannel.trigger('app:navigate', 'devices', true)
  },
  onPeriodClick: function (ev) {
    var period = ev.currentTarget.getAttribute('data-period')
    this.toggleListDeactivate()
    ev.currentTarget.classList.add('active')
    this.activePeriod = period
    this.updateCharts()
  },

  /* Methods ----------------------------------------------------------------- */
  toggleListDeactivate: function () {
    var periods = this.el.querySelectorAll('.js-kpi-toggle .js-toggle-list')
    for (var i = 0; i < periods.length; i++) {
      var periodToggle = periods[i]
      periodToggle.classList.remove('active')
    }
  },
  /** Update the charts based on activePeriod */
  updateCharts: function () {
    var status = this.model.get('status')
    var settings = this.model.get('settings')
    if (!status) return false

    var stats = status[this.activePeriod]

    this.chartUsage.setValue(stats.totalWh || 0)
    this.chartCosts.setValue(stats.totalEnergyCost || 0)
    this.chartCo2.setValue(stats.totalCo2 || 0)

    var prevSituationStatus = {
      usage: 0,
      costs: 0,
      co2: 0
    }

    switch (this.activePeriod) {
      case 'ytd':
        prevSituationStatus.usage = settings.prevKwhYear
        break
      case 'mtd':
        prevSituationStatus.usage = settings.prevKwhYear / 12
        break
      case 'wtd':
        prevSituationStatus.usage = settings.prevKwhYear / 52
        break
    }

    // Calculate Co2 ( 0.57 * kWh * hourspan )
    prevSituationStatus.co2 = 0.57 * prevSituationStatus.usage * 8
    // Calculate usage costs
    prevSituationStatus.costs = prevSituationStatus.usage * settings.pricePerKwh

    //
    this.chartPrevUsage.setValue(prevSituationStatus.usage)
    this.chartPrevCosts.setValue(prevSituationStatus.costs)
    this.chartPrevCo2.setValue(prevSituationStatus.co2)
  }
})
module.exports.Layout = Layout

/**
 * System View
 * -----------------------------------------------------------------------------
 */
var System = Marionette.View.extend({
  template: require('./templates/system.html'),
  initialize: function () {
  },
  modelEvents: {
    'change': 'render'
  },
  templateContext: function () {
    return {
      getConnectedPercent: function () {
        var total = _.get(this, 'status.devices.total') || 0
        var online = _.get(this, 'status.devices.online') || 5
        return Math.round((online / total) * 100)
      },
      getAttribute: App.TemplateHelpers.getAttribute
    }
  }
})
module.exports.SystemLayout = System



// WEBPACK FOOTER //
// ./js/modules/page-status/show/view.js